<template>
  <section class="imageBlock container defaultSectionMargins">
    <template v-for="item in ['left_image', 'righ_small_image', 'right_image']">
      <FlarePicture
        v-if="data[item]"
        :src="{
          1920: { src: data[item], width: 644, height: 488, size: 'both', crop: 'fill' },
        }"
        :alt="data[item]"
      />
    </template>
  </section>
</template>

<script setup>
  defineProps({
    data: {},
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_imageBlock.scss');
</style>